import React, { useEffect } from 'react';
import { cn } from '../../utils/cn';
import Icon from '../AppIcon';
import { useNotifications } from '../../contexts/NotificationContext';

const Toast = ({ toast }) => {
  const { removeToast } = useNotifications();

  const getIcon = () => {
    switch (toast?.type) {
      case 'delay':
        return { name: 'Clock', color: 'var(--color-warning)' };
      case 'gate_change':
        return { name: 'MapPin', color: 'var(--color-accent-blue)' };
      case 'status_update':
        return { name: 'Info', color: 'var(--color-accent-cyan)' };
      case 'cancellation':
        return { name: 'XCircle', color: 'var(--color-error)' };
      case 'success':
        return { name: 'CheckCircle', color: 'var(--color-success)' };
      case 'error':
        return { name: 'AlertCircle', color: 'var(--color-error)' };
      default:
        return { name: 'Bell', color: 'var(--color-accent-cyan)' };
    }
  };

  const getBackgroundClass = () => {
    switch (toast?.type) {
      case 'delay':
        return 'bg-warning/10 border-warning/30';
      case 'gate_change':
        return 'bg-accent-blue/10 border-accent-blue/30';
      case 'cancellation': case'error':
        return 'bg-error/10 border-error/30';
      case 'success':
        return 'bg-success/10 border-success/30';
      default:
        return 'bg-accent-cyan/10 border-accent-cyan/30';
    }
  };

  const icon = getIcon();

  return (
    <div
      className={cn(
        'flex items-start gap-3 p-4 rounded-lg border backdrop-blur-sm shadow-lg',
        'animate-in slide-in-from-right duration-300',
        'min-w-[320px] max-w-[420px]',
        getBackgroundClass()
      )}
    >
      <Icon name={icon?.name} size={20} color={icon?.color} className="flex-shrink-0 mt-0.5" />
      
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground mb-1">
          {toast?.title}
        </p>
        {toast?.message && (
          <p className="text-xs text-muted-foreground">
            {toast?.message}
          </p>
        )}
      </div>

      <button
        onClick={() => removeToast(toast?.id)}
        className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Close notification"
      >
        <Icon name="X" size={16} />
      </button>
    </div>
  );
};

export default Toast;